import styled from 'styled-components/macro';
import {themecolors} from "../utils/themecolors";

const Title = styled.div``;

const Suspended = styled(({className}) => {
    return (
        <div className={className}>
            <Title>
                Account suspended.
            </Title>
            <p>
                Your account is now read-only due to violations of our Content Policy.
            </p>
        </div>
    )})`
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
  margin-bottom: 12px;
  padding: 16px 20px;
  font-weight: 500;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  
  p {
    font-weight: 400;
    font-size: 15px;
  }
  @media only screen and (max-width: 780px) {
    & {
      border-radius: 0;
    }
  }
`;

export default Suspended;
